import {Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';

import {Consts} from '../../../../../commons/consts/consts';
import {Vehicle} from "@commons/models/domain/Vehicle";

@Component({
  selector: 'tk-vehicle-list-full-inidicator-value-header',
  templateUrl: './vehicle-list-full-indicator-value-header.component.html',
  styleUrls: ['./vehicle-list-full-indicator-value-header.component.less']
})
export class VehicleListFullIndicatorValueHeaderComponent implements OnChanges {
  @Output()
  public onValueChanged: EventEmitter<any> = new EventEmitter();

  @ViewChild('select__toggle', {read: ElementRef}) selectButton: any;

  public showList = false;

  @Input()
  public currentValue?: string | null;

  public items: string[] = [];

  @Input()
  vehicles?: Vehicle[];

  constructor(
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.vehicles && this.items.length === 0)
      this.setItems();
  }

  private setItems() {
    const allIndicators = this.vehicles!.map(v => v.ControlIndicators).flat();
    const items = allIndicators.filter(i => (Consts.binaryIndicators.indexOf(i!.Tp) !== -1));
    const sorted = [];
    for (const v of items) {
      if (v && v.Nm) {
        if (sorted.indexOf(v.Nm) === -1) {
          sorted.push(v.Nm);
        }
      }
    }
    this.items = sorted.sort();
  }

  public toggleShowList() {
    this.showList = !this.showList;
    if (this.showList === true) {
      this.selectButton.nativeElement.focus();
    }
  }

  public closeShowList() {
    setTimeout(() => {
      this.showList = false;
    }, 300);
  }


  onSelect(val: string) {
    this.currentValue = val;
    this.onValueChanged.emit(val);
    this.toggleShowList();
  }

}
